"use client";

import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const VendorDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [previewImage, setPreviewImage] = useState(null);

  const navigate = useNavigate();

  // counters
  const [pendingOrder, setPendingOrder] = useState(0);
  const [packedOrder, setPackedOrder] = useState(0);
  const [paymentDue, setPaymentDue] = useState(0);
  const [paymentPaid, setPaymentPaid] = useState(0);

const [vendorDueAmount, setVendorDueAmount] = useState(0);
const [vendorPaidAmount, setVendorPaidAmount] = useState(0);

  const headers = {
    authorization: localStorage.getItem("accessToken"),
    "Content-Type": "application/json",
  };

  const fetchOrders = async () => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/pixel-get-all-order-for-vendor`,
        { headers }
      );
      // Filter only confirmed orders
      const confirmedOrders = (res.data?.data || []).filter(
        (o) => String(o.order_status).toLowerCase() !== "pending"
      );

      // Sort latest first
      const sorted = confirmedOrders.sort(
        (a, b) => new Date(b.order_date) - new Date(a.order_date)
      );

      setOrders(sorted);

      //counters
      setPendingOrder(
        sorted.length
      );

      setPackedOrder(
        sorted.filter(o => String(o.vendor_order_status).toLowerCase() === "packed").length
      );

      setPaymentDue(
        sorted.filter(o => String(o.vendor_payment_status).toLowerCase() === "pending").length
      );

      setPaymentPaid(
        sorted.filter(o => String(o.vendor_payment_status).toLowerCase() === "paid").length
      );


    } catch (err) {
      setOrders([]);
    }
  };

  const fetchProducts = async () => {
    try {
      const res = await axios.get(
        `https://logicx.premierlam.com/api/get-pixel-products-for-vendor`,
        { headers }
      );
      const sorted = [...res.data?.data].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
      setProducts(sorted);
    } catch (err) {
      setProducts([]);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchOrders();
    fetchProducts();
    fetchVendorDuePaidAmount();
    setTimeout(() => setLoading(false), 800);
  }, []);

  const DashboardCard = ({ title, morePath, data, columns, renderRow }) => (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 w-full min-h-[300px] mb-6 hover:shadow-md transition">
      <div className="flex justify-between items-center mb-3 border-b pb-2">
        <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
        <button
          onClick={() => navigate(morePath)}
          className="text-orange-600 text-sm hover:text-orange-700 font-medium transition"
        >
          View All →
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center py-8">
          <div className="animate-spin h-8 w-8 border-b-2 border-orange-500 rounded-full"></div>
        </div>
      ) : data.length === 0 ? (
        <p className="text-gray-500 text-center py-4">No Records Found</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200 bg-gray-50">
                {columns.map((col, i) => (
                  <th key={i} className="px-3 py-2 text-gray-600 font-medium whitespace-nowrap text-left">
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((item, i) => (
                <tr key={i} className="border-b hover:bg-orange-50 transition">
                  {renderRow(item)}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
const fetchVendorDuePaidAmount = async () => {
  try {
    const res = await axios.get(
      "https://logicx.premierlam.com/api/pixel-get-vendor-due-paid-payments",
      { headers }
    );

    const data = res?.data || {};

    setVendorDueAmount(data["Vendor Payment Due"] || 0);
    setVendorPaidAmount(data["Vendor Payment Paid"] || 0);

  } catch (err) {
    setVendorDueAmount(0);
    setVendorPaidAmount(0);
  }
};

  return (
    <div className="min-h-screen bg-gray-100 p-6">

      {/* VENDOR COUNTERS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">

        {/* Pending Orders */}
        <div className="bg-white border rounded-lg shadow-sm p-5 flex items-center justify-between">
          <div>
            <p className="text-gray-600 text-sm">Pending Orders</p>
            <h2 className="text-3xl font-semibold text-gray-900">{pendingOrder}</h2>
          </div>
          <div className="bg-yellow-100 text-yellow-600 p-3 rounded-full">⏳</div>
        </div>

        {/* Packed Orders */}
        <div className="bg-white border rounded-lg shadow-sm p-5 flex items-center justify-between">
          <div>
            <p className="text-gray-600 text-sm">Orders Packed</p>
            <h2 className="text-3xl font-semibold text-gray-900">{packedOrder}</h2>
          </div>
          <div className="bg-blue-100 text-blue-600 p-3 rounded-full">📦</div>
        </div>

        {/* Payment Due */}
        <div className="bg-white border rounded-lg shadow-sm p-5 flex items-center justify-between">
          <div>
            <p className="text-gray-600 text-sm">Payment Due</p>
            <h2 className="text-3xl font-semibold text-gray-900">{vendorDueAmount}</h2>
          </div>
          <div className="bg-red-100 text-red-600 p-3 rounded-full">💰</div>
        </div>

        {/* Paid Till Now */}
        <div className="bg-white border rounded-lg shadow-sm p-5 flex items-center justify-between">
          <div>
            <p className="text-gray-600 text-sm">Paid Till Now</p>
            <h2 className="text-3xl font-semibold text-gray-900">{vendorPaidAmount}</h2>
          </div>
          <div className="bg-green-100 text-green-600 p-3 rounded-full">✅</div>
        </div>

      </div>


      {/* ORDERS SECTION */}
      <DashboardCard
        title="Recent Orders"
        morePath="/all-vendor-order"
        data={orders}
        columns={[
          "Order ID", "Date", "Medium", "Order Status", "Vendor Payment Status", "Shipping Label",
          "Vendor Order Status", "Order Details"
        ]}
        renderRow={(o) => (
          <>
            <td className="px-3 py-2">{o.order_id}</td>
            <td className="px-3 py-2">{new Date(o.order_date).toLocaleDateString()}</td>
            <td className="px-3 py-2">{o.order_medium}</td>
            <td className="px-3 py-2">{o.order_status}</td>
            <td className="px-3 py-2">{o.vendor_payment_status}</td>
            <td className="px-3 py-2">{o.shipping_label}</td>
            <td className="px-3 py-2">{o.vendor_order_status}</td>
            <td className="px-3 py-2">{o.order_details}</td>
            {/* <td className="px-3 py-2">{o.number_of_items}</td> */}

          </>
        )}
      />

      {/* PRODUCTS SECTION */}
      <DashboardCard
        title="Recent Products"
        morePath="/all-vendor-product"
        data={products}
        columns={[
          "Image", "Code", "Name", "Category", "Material", "Color", "Cost", "Selling",
          "Description", "Vendor", "Added By", "Created"
        ]}
        renderRow={(p) => (
          <>
            <td className="px-3 py-2">
              <img
                src={p.product_image}
                className="w-12 h-12 object-cover rounded border cursor-pointer"
                onClick={() => setPreviewImage(p.product_image)}
              />
            </td>
            <td className="px-3 py-2">{p.product_code}</td>
            <td className="px-3 py-2">{p.product_name}</td>
            <td className="px-3 py-2">{p.category_name}</td>
            <td className="px-3 py-2">{p.product_material}</td>
            <td className="px-3 py-2">{p.product_color || "-"}</td>
            <td className="px-3 py-2">{p.product_cost_price}</td>
            <td className="px-3 py-2">{p.product_selling_price}</td>
            <td className="px-3 py-2">{p.product_description}</td>
            <td className="px-3 py-2">{p.vendor_name}</td>
            <td className="px-3 py-2">{p.added_by}</td>
            <td className="px-3 py-2">{new Date(p.created_at).toLocaleDateString()}</td>
          </>
        )}
      />

      {/* IMAGE PREVIEW POPUP */}
      {previewImage && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50">
          <div className="bg-white p-4 rounded-lg max-w-2xl w-full relative">
            <button
              className="absolute top-3 right-3 text-gray-700 hover:text-black"
              onClick={() => setPreviewImage(null)}
            >
              ✖
            </button>

            <img src={previewImage} className="w-full object-contain max-h-[70vh]" />

            <div className="flex justify-end mt-4">
              <a
                href={previewImage}
                download
                className="px-4 py-2 bg-orange-500 text-white rounded hover:bg-orange-600"
              >
                Download
              </a>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default VendorDashboard;



// "use client"

// import { useState, useEffect } from "react"
// import axios from "axios"
// import { useNavigate } from "react-router-dom"

// const VendorDashboard = () => {
//   const [orders, setOrders] = useState([])
//   const [products, setProducts] = useState([])
//   const [loading, setLoading] = useState(true)

//   const navigate = useNavigate()

//   const headers = {
//     authorization: localStorage.getItem("accessToken"),
//     "Content-Type": "application/json",
//   }

//   const fetchOrders = async () => {
//     try {
//       const res = await axios.get(
//         `https://logicx.premierlam.com/api/pixel-get-all-order-for-vendor`,
//         { headers }
//       )
//       const list = res.data?.data || []

//       const top5 = [...list]
//         .sort((a, b) => new Date(b.order_date) - new Date(a.order_date))
//         .slice(0, 5)

//       setOrders(top5)
//     } catch (err) {
//       setOrders([])
//     }
//   }

//   const fetchProducts = async () => {
//     try {
//       const res = await axios.get(
//         `https://logicx.premierlam.com/api/get-pixel-products-for-vendor`,
//         { headers }
//       )
//       const list = res.data?.data || []

//       const top5 = [...list]
//         .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
//         .slice(0, 5)

//       setProducts(top5)
//     } catch (err) {
//       setProducts([])
//     }
//   }

//   useEffect(() => {
//     setLoading(true)
//     fetchOrders()
//     fetchProducts()
//     setTimeout(() => setLoading(false), 800)
//   }, [])

//   const DashboardCard = ({ title, morePath, data, columns, renderRow }) => (
//     <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-5 w-full min-h-[300px] mb-6 hover:shadow-md transition">
//       <div className="flex justify-between items-center mb-3 border-b pb-2">
//         <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
//         <button
//           onClick={() => navigate(morePath)}
//           className="text-indigo-600 text-sm hover:text-indigo-800 font-medium transition"
//         >
//           View All →
//         </button>
//       </div>

//       {loading ? (
//         <div className="flex justify-center py-8">
//           <div className="animate-spin h-8 w-8 border-b-2 border-orange-500 rounded-full"></div>
//         </div>
//       ) : data.length === 0 ? (
//         <p className="text-gray-500 text-center py-4">No Records Found</p>
//       ) : (
//         <div className="overflow-x-auto">
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="border-b border-gray-200 bg-gray-50">
//                 {columns.map((col, i) => (
//                   <th
//                     key={i}
//                     className="px-3 py-2 text-gray-600 font-medium whitespace-nowrap text-left"
//                   >
//                     {col}
//                   </th>
//                 ))}
//               </tr>
//             </thead>

//             <tbody>
//               {data.map((item, i) => (
//                 <tr key={i} className="border-b hover:bg-orange-50 transition cursor-pointer">
//                   {renderRow(item)}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   )

//   return (
//     <div className="min-h-screen bg-gray-100 p-6">

//       {/* RECENT ORDERS */}
//       <DashboardCard
//         title="Recent Orders"
//         morePath="/all-vendor-orders"
//         data={orders}
//         columns={["Order ID", "Date", "Medium", "Status", "Vendor Status", "Items"]}
//         renderRow={(o) => (
//           <>
//             <td className="px-3 py-2">{o.order_id}</td>
//             <td className="px-3 py-2">{new Date(o.order_date).toLocaleDateString()}</td>
//             <td className="px-3 py-2">{o.order_medium}</td>
//             <td className="px-3 py-2 capitalize">{o.order_status}</td>
//             <td className="px-3 py-2 capitalize">{o.vendor_order_status}</td>
//             <td className="px-3 py-2">{o.number_of_items}</td>
//           </>
//         )}
//       />

//       {/* RECENT PRODUCTS */}
//       <DashboardCard
//         title="Recent Products"
//         morePath="/all-vendor-products"
//         data={products}
//         columns={["Image", "Name", "Category", "Material", "Price", "Created"]}
//         renderRow={(p) => (
//           <>
//             <td className="px-3 py-2">
//               <img
//                 src={p.product_image}
//                 className="w-12 h-12 object-cover rounded border"
//                 alt=""
//               />
//             </td>
//             <td className="px-3 py-2">{p.product_name}</td>
//             <td className="px-3 py-2">{p.category_name}</td>
//             <td className="px-3 py-2">{p.product_material}</td>
//             <td className="px-3 py-2">{p.product_selling_price}</td>
//             <td className="px-3 py-2">{new Date(p.created_at).toLocaleDateString()}</td>
//           </>
//         )}
//       />
//     </div>
//   )
// }

// export default VendorDashboard
